import { StaffingPostingDetailPage } from '@/pages/staffing/StaffingPostingDetailPage';
import { getRouteApi, createFileRoute } from '@tanstack/react-router';

const routeApi = getRouteApi('/_authenticated/_app/staffing/postings/$id');

function StaffingPostingDetailRoute() {
	const { id } = routeApi.useParams();
	return <StaffingPostingDetailPage postingId={id} />;
}

export const Route = createFileRoute('/_authenticated/_app/staffing/postings/$id')({
	component: StaffingPostingDetailRoute,
});
